import type { SttRealtimeSession } from '@hub/contracts'
import { createElevenLabsTransport } from './elevenlabs-transport'
import { createSonioxTransport } from './soniox-transport'
import type { DictationTransport } from './transport'

export { DictationError } from './transport'
export type { DictationHandlers, DictationTransport } from './transport'

/** The only provider switch in the SPA. */
export function transportFor(session: SttRealtimeSession): DictationTransport {
  switch (session.provider) {
    case 'soniox':
      return createSonioxTransport()
    case 'elevenlabs':
      return createElevenLabsTransport()
  }
}
